<header
  [class.absolute]="positionAbsoluteOnMobile()"
  [class.pt-8]="isNotched"
  [ngClass]="positionAbsoluteOnDesktop() ? 'md:absolute' : 'md:relative'"
  class="z-30 mx-auto w-full"
>
  <div
    class="flex w-full items-center justify-between overflow-x-auto px-5 py-4 scrollbar-hide lg:px-12"
    [style.backgroundColor]="backgroundColor() | contentBuilderColor"
  >
    <div
      class="flex flex-shrink items-center justify-start scrollbar-hide md:overflow-x-auto relative z-30"
    >
      @if (
        (displayLogo() && !logoOptions()?.position) ||
        (displayLogo() && logoOptions()?.position === 'left')
      ) {
        <a
          [link]="'/'"
          class="shrink-0 z-10 hidden xl:block"
        >
          <img
            class="h-12 max-w-[120px] xl:max-w-none"
            [style.max-width]="logoOptions()?.maxWidth ?? undefined"
            [style.max-height]="logoOptions()?.maxHeight ?? undefined"
            [style.object-fit]="logoOptions()?.objectFit ?? 'contain'"
            src="{{ logoImageUrl() }}"
            alt=""
          />
        </a>
      }
      @if (displayBackButton()) {
        <app-rounded-icon-button
          class="relative z-30"
          [icon]="'icon-arrow-left'"
          [type]="'light'"
          [size]="isNotched ? 'isNotched' : 'md'"
          [color]="'neutral'"
          [overrideBackgroundColor]="iconBackgroundColor()"
          [overrideColor]="iconColor()"
          (click)="back()"
          data-testid="header-back-button"
        ></app-rounded-icon-button>
      }
      <div class="flew-row ml-2 mr-4 flex flex-shrink items-center">
        <app-block-list [blockIdList]="leftBlocks()"></app-block-list>
        @if (navigationLinks() && !isMobileScreenType) {
          <app-block-list [blockIdList]="navigationLinks() ?? []"></app-block-list>
        }
      </div>
    </div>

    @if (titleSignal(); as title) {
      <h1 class="block text-center font-accent text-md font-bold lg:hidden">
        {{ title | translate }}
      </h1>
    }
    @if (displayLogo() && logoOptions()?.position === 'center') {
      <img
        class="absolute left-1/2 h-12 max-w-none -translate-x-1/2 transform"
        [style.max-width]="
          logoOptions()?.maxWidth ? logoOptions()?.maxWidth + '!important' : undefined
        "
        [style.max-height]="
          logoOptions()?.maxHeight ? logoOptions()?.maxHeight + '!important' : undefined
        "
        [style.object-fit]="logoOptions()?.objectFit ?? 'contain'"
        src="{{ logoImageUrl() }}"
        alt=""
      />
    }

    <div class="-mr-4 flex flex-shrink-0 flex-row items-center justify-end">
      @if (isShopSearchAddressVisibleSignal()) {
        <!-- Shop search address -->
        <div class="mr-4 hidden w-96 rounded-full lg:block relative z-20">
          <app-shop-search-location-input
            [fieldBackgroundColor]="shopSearchLocationFieldBackgroundColor()"
            [fieldTextColor]="shopSearchLocationFieldTextColor()"
            [fieldPlaceholderColor]="shopSearchLocationFieldPlaceholderColor()"
            [fieldIconColor]="shopSearchLocationFieldIconColor()"
          ></app-shop-search-location-input>
        </div>
      }

      <!-- Logo à droite de la barre de recherche sur petits écrans -->
      @if (
        (displayLogo() && !logoOptions()?.position) ||
        (displayLogo() && logoOptions()?.position === 'left')
      ) {
        <a
          [link]="'/'"
          class="shrink-0 ml-4 block xl:hidden relative z-30"
        >
          <img
            class="h-12 max-w-[120px]"
            [style.max-width]="logoOptions()?.maxWidth ?? undefined"
            [style.max-height]="logoOptions()?.maxHeight ?? undefined"
            [style.object-fit]="logoOptions()?.objectFit ?? 'contain'"
            src="{{ logoImageUrl() }}"
            alt=""
          />
        </a>
      }

      <!-- Shop search parameters -->
      @if (isShopSearchParametersVisibleSignal()) {
        <div class="mr-4 hidden rounded-full lg:block">
          <app-shop-search-parameters-overview
            [iconBackgroundColor]="iconBackgroundColor()"
            [iconColor]="iconColor()"
            [textColor]="labelColor()"
          ></app-shop-search-parameters-overview>
        </div>
      }

      <!-- Cart parameters -->
      @if (isCartParametersVisibleSignal()) {
        <div class="mr-4 hidden rounded-full lg:block">
          <app-cart-parameters-overview
            [iconBackgroundColor]="iconBackgroundColor()"
            [iconColor]="iconColor()"
            [textColor]="labelColor()"
          ></app-cart-parameters-overview>
        </div>
      }

      <!-- Cart button -->
      @if (isCartButtonVisibleSignal()) {
        <div class="mr-4 hidden rounded-full lg:block">
          <app-button-atom
            [size]="'L'"
            [type]="'primary'"
            [disabled]="isNavigationToCartInProgress"
            [icon]="!isNavigationToCartInProgress ? 'icon-shopping-bag' : ''"
            [iconUrl]="isNavigationToCartInProgress ? 'assets/images/spinner.svg' : ''"
            [label]="('shop-page.basket' | translate) + ' (' + cartLineItemsTotalQuantity() + ')'"
            [overrideBgColor]="buttonBackgroundColor()"
            [overrideTextColor]="buttonTextColor()"
            (click)="navigateToCart()"
          ></app-button-atom>
        </div>
      }

      @if (displayHamburger()) {
        <div class="ml-5 mr-4 flex">
          <div class="flew-row flex flex-shrink items-center">
            <app-block-list [blockIdList]="rightBlocks() ?? []"></app-block-list>
          </div>
          @if (languageFlagUrl()) {
            <app-header-language-flag-atom
              [languageFlagUrl]="languageFlagUrl()!"
              (click)="onLanguageFlagClick($event)"
            ></app-header-language-flag-atom>
          }
          <div class="flex items-center">
            <app-hamburger-menu-atom
              [color]="hamburgerColor()"
              [class.md:hidden]="navigationLinks()?.length"
              [light]="positionAbsoluteOnMobile() && isMobileScreenType"
              (click)="navigationLinks()?.length ? toggleStaticNav() : onClick($event)"
            ></app-hamburger-menu-atom>
          </div>
        </div>
      }
    </div>
  </div>
</header>
<nav
  class="z-100 w-screen bg-neutral-800"
  [ngClass]="isOpenStaticNav ? 'fixed top-0 bottom-0 left-0 right-0' : 'hidden'"
>
  <div class="flex h-screen flex-col justify-center text-center">
    <header class="absolute top-0 w-full p-5">
      <div class="flex justify-between">
        <span></span>
        <span
          ><i
            class="icon icon-cross text-white"
            (click)="toggleStaticNav()"
          ></i
        ></span>
      </div>
    </header>
    <div class="self-center">
      @if (navigationLinks()) {
        <app-block-list
          class="overflow-x-scroll bg-white"
          [blockIdList]="navigationLinks() ?? []"
          (click)="toggleStaticNav()"
        ></app-block-list>
      }
      <app-block-list [blockIdList]="rightBlocks() ?? []"></app-block-list>
    </div>
  </div>
</nav>
